import { IonButton, IonCol, IonContent, IonIcon, IonPage, IonRow, IonText, IonInput,IonSpinner } from "@ionic/react"
import Head from "../Header"
import Sidebar from "../Sidebar"
import Select from "react-select"
import DataTable from "react-data-table-component";
import { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router";
import { searchOutline, chevronDownOutline } from "ionicons/icons";
import service from "../../Service/service";
import swal from 'sweetalert';
import "../../theme/style2.css"

const MemberTimesheetHistory: React.FC = () => {
    const [business, setBusiness] = useState("");
    const [department, setDeapartment] = useState("");
    const [businessUnitArr, setBusinessUnitArr] = useState([]);
    const [departmentUnitArr, setDepartmentUnitArr] = useState([]);
    const history = useHistory();
    const [roleuser] = useState(localStorage.getItem("UserRole"));
    const [createdBy]: any = useState(localStorage.getItem("SignupEmpId"));
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [status,setstatus] = useState('');
    const [data, setData] = useState([]);
    const [loading,setloading]=useState(false)
    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        } else {
        }
    }, [Id, history]);

    //---------------Business unit Autocomplete------------------//

    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const handleStateChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
    };
    const handleInputChange = (inputValue: any) => {
        setInputValue(inputValue);
    };

    const handleMenuOpen = () => {
        setMenuIsOpen(true);
    };

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };
    const Placeholder = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span>Select Business Unit</span>;
        } else {
            return <span>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "#BBB9B9", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "#BBB9B9", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const options = [

        ...businessUnitArr.map((state: any) => ({
            value: state.id,
            label: state.businessUnitName,
        })),
        {
            value: 'all',
            label: 'All',
        },
    ];
    const handleBusinessUnitChange = (selectedOption: any) => {
        console.log(selectedOption.value, "kn");
        setBusiness(selectedOption.value);
        ViewAllDepartmentunit(selectedOption.value);
    };
   
//----------------------Department AutoComplete-----------------------//

    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [departmentInputValue, setDepartmentInputValue] = useState('');
    const [departmentIsFocused, setDepartmentIsFocused] = useState(false);
    const [departmentMenuIsOpen, setDepartmentMenuIsOpen] = useState(false);

    const handleDepartmentChange = (selectedOption: any) => {
        setSelectedDepartment(selectedOption);
    };

    const handleDepartmentInputChange = (inputValue: any) => {
        setDepartmentInputValue(inputValue);
    };

    const handleDepartmentMenuOpen = () => {
        setDepartmentMenuIsOpen(true);
    };

    const handleDepartmentMenuClose = () => {
        setDepartmentMenuIsOpen(false);
    };

    const handleDepartmentFocus = () => {
        setDepartmentIsFocused(true);
    };

    const handleDepartmentBlur = () => {
        setDepartmentIsFocused(false);
    };

    const DepartmentPlaceholder = () => {
        if (
            departmentInputValue === '' &&
            !selectedDepartment &&
            !departmentIsFocused
        ) {
            return <span>Select Department Unit</span>;
        } else {
            return <span>Type to Search Here...</span>;
        }
    };
    const DepartmentDropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "#BBB9B9", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "#BBB9B9", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const departmentOptions = [
        ...departmentUnitArr.map((state: any) => ({
            value: state.id,
            label: state.departmentName,

        })),
        {
            value: 'all',
            label: 'All',
        },
    ];
    const handleDepartmentUnitChange = (selectedOption: any) => {
        setDeapartment(selectedOption.value);
    };

//----------------------Navigate to viewtimesheet------------------//

    const View = (id: any) => {
        console.log(id, "g")
        history.push({ pathname: "/HRViewTimesheetHistory", state: { Id: id } })
    }

    //------------------Getall Timesheet Datatable----------------------//

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: true,
            width: "100px",
        },
        {
            name: "Employee Name",
            selector: (itm: any) => itm.name,
            sortable: true,
            sort: "name",
            width: "300px",
            cell: (itm: any) => (
                <>
                    <div className="wrapper_cls">{itm.name}{" ("}{itm.employeeCode}{")"}</div>
                </>
            )
        },
        {
            name: "Role",
            selector: (itm: any) => itm.role,
            sortable: true,
            width: "230px",
            cell: (itm: any) => (
                <>
                    {itm.role === "TEAM_MEMBER" ? <IonText>Team Member</IonText>
                        : itm.role === "TEAM_LEADER" ? <IonText>Team Leader</IonText>
                            : itm.role === "HR" ? <IonText>Hr</IonText>
                                : itm.role === "MANAGER" ? <IonText>Manager </IonText>
                                    : itm.role}
                </>
            )
        },
        {
            name: "Email",
            selector: (itm: any) => itm.emailId,
            sortable: true,
            width: "300px"
        },
        {
            name: "Action",
            sortable: false,
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral", textUnderlinePosition: "under" }}>
                        <IonText onClick={() => View(itm.id)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
                    </div>
                </>
            )
        }
    ];

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                justifyContent: "center"
            },
        },
        cells: {
            style: {
                fontSize: "16px",
                justifyContent: "center"
            }
        }
    };

   //-------------------Getall Timesheet History Api--------------//

    useEffect(() => {
        LoadEmployee();
    }, []);
    const LoadEmployee = () => {
        setloading(true);
        service.ManagerGetAllTeams(Id)
            .then((response) => {
                console.log(response);
                console.log("Employee List", response.data.Data);
                if (response.data.Status === "200") {
                    setData(response.data.Data);
                    ViewAllBusinessunit();
                }
                else {
                    setData([]);
                }
            })
            .catch((error) => {
                swal(error);
            })
            .finally(() => {
                // This code will execute whether the promise is resolved or rejected
                setTimeout(() => {
                    setloading(false); // Hide loading after a delay (e.g., 1000 milliseconds)
                }, 500); // Adjust the timeout duration as needed
            });
    }
    
//---------------------Sorting Api--------------------//

const Empsort = () => {
    setloading(true);
    service.SearchEmployeeByBussinessUnit(createdBy, business, department, status)
        .then((response) => {
            console.log(response);
            if (response.data.Status === "200") {
                setData(response.data.Data);
                // sortedTableData()
            } else {
                setData([]);
            }
        })
        .catch((error) => {
            swal(error);
        })
        .finally(() => {
            setTimeout(() => {
                setloading(false); 
            }, 500);
        });
}

    //-----------------Businessunit Dropdown Api----------------//

    const ViewAllBusinessunit = () => {
        service.GetBusinessunitEmployee(Id)

            .then((response) => {
                console.log("Bussiness Unit")
                console.log(response);
                if (response.data.Status === "200") {
                    setBusinessUnitArr(response.data.Data)
                    ViewAllDepartmentunit1()

                }
                else {
                    setBusinessUnitArr([])
                }
            })
    }

//-------------------Department Dropdown api-------------------// 

    const ViewAllDepartmentunit = (id: any) => {
        // setDepartmentUnitArr([]);
        setDeapartment("");
        service.GetAllDepartmentUnitDropDown(id)
            .then((response) => {
                console.log("Department Unit")
                console.log(response);
                if (response.data.Status === "200") {
                    setDepartmentUnitArr(response.data.Data)
                } else {
                    setBusinessUnitArr([])
                }
            })
    }

    const ViewAllDepartmentunit1 = () => {
        service.GetAllDepartmentUnitDropDown(business)
            .then((response) => {
                console.log("Department Unit")
                console.log(response);
                if (response.data.Status === "200") {
                    setDepartmentUnitArr(response.data.Data)
                } else {
                    setDepartmentUnitArr([])
                }
            })
    }
    const back = () => {
        history.goBack();
    }
    //-------------------Search Filter------------------//

    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };
        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="row">
                            <div className="col">
                                <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                    My Employees Timesheet History</h3>
                            </div>
                        </div>
                    </div>
                    <div>
                        <form className="row addmore">
                            <div className="form-group col-md-3">
                                <label style={{ fontWeight: "bold" }}>
                                    Business Unit<span className="text-danger">*</span>
                                </label>
                                <div>
                                    <Select
                                        options={options}
                                        value={options.find((option) => option.value === business) || null}
                                        onChange={handleBusinessUnitChange}
                                        onInputChange={handleInputChange}
                                        onMenuOpen={handleMenuOpen}
                                        onMenuClose={handleMenuClose}
                                        onFocus={handleFocus}
                                        onBlur={handleBlur}
                                        menuIsOpen={menuIsOpen}
                                        isSearchable
                                        placeholder={<Placeholder />}
                                        components={{
                                            DropdownIndicator: DropdownIndicator,
                                        }}
                                        className="custom-select2"
                                    />
                                </div>
                            </div>
                            <div className="form-group col-md-3">
                                <label style={{ fontWeight: "bold" }}>
                                    Department Unit <span className="text-danger">*</span>
                                </label>
                                <div>
                                    <Select
                                        options={departmentOptions}
                                        value={departmentOptions.find((option) => option.value === department) || null}
                                        onChange={handleDepartmentUnitChange}
                                        onInputChange={handleDepartmentInputChange}
                                        onMenuOpen={handleDepartmentMenuOpen}
                                        onMenuClose={handleDepartmentMenuClose}
                                        onFocus={handleDepartmentFocus}
                                        onBlur={handleDepartmentBlur}
                                        menuIsOpen={departmentMenuIsOpen}
                                        isSearchable
                                        placeholder={<DepartmentPlaceholder />}
                                        components={{
                                            DropdownIndicator: DepartmentDropdownIndicator,
                                        }}
                                        className="custom-select"
                                    />
                                </div>
                            </div>
                            <div className="form-group col-md-3">
                                <label>
                                    <span className="text-danger"></span>
                                </label>
                                <div>
                                    <button onClick={() => Empsort()} type="button" className="btn btn-primary submit-btn">
                                        Search
                                    </button>
                                </div>
                            </div>

                        </form>
                    </div>
                    {loading && (
                            <div
                                style={{
                                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                }}
                            >
                                <div >
                                    <IonSpinner style={{
                                        width: "40px",
                                        height: "40px",
                                        color: "#ff8a53"
                                    }} name="lines" />
                                </div>
                            </div>
                        )}
                    <div className="table-responsive">
                        <DataTable
                            columns={columns}
                            data={datatable}
                            pagination
                            paginationPerPage={10}
                            paginationComponentOptions={paginationComponentOptions}
                            paginationRowsPerPageOptions={[10, 20, 30]}
                            subHeader
                            subHeaderComponent={subHeaderComponent}
                            customStyles={customStyles}
                        />
                    </div>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default MemberTimesheetHistory